import React, { FC } from "react";

import CampaignBuilderForm from "../../components/redesign/modules/CampaignBuilderForm";
import { CAMPAIGN_PLAY_TYPE } from "../../constants/campaignPlayTypes";
import { CAMPAIGN_STEPS } from "../../types/campaignTypes";

const GeoTargetingCreatePageRedesign: FC = () => (
  <CampaignBuilderForm
    mode="campaign"
    campaignPlayType={CAMPAIGN_PLAY_TYPE.GEO_TARGETING}
    visibleOptionalPanels={[CAMPAIGN_STEPS.ZIP_CODES, CAMPAIGN_STEPS.STATE_PROVINCES]}
  />
);

export default GeoTargetingCreatePageRedesign;
